import apiClient from '@/services/axios'

export async function put(event) {
  var response = await apiClient.put('/ActivationPlanEvents/', event)
  if (response) {
    return response.data
  }

  throw new Error('Unable to update event.')
}